import { Component, OnInit } from '@angular/core';
import { BaseActComponent } from 'app/_controls/base-act.component';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { GeoType } from 'app/_core/predefined/enums';
import { SeniorPlacementFilter, PageInfo, ListOfValues } from 'app/_core/models';
import { GlobalService } from 'app/_core/api-access/global.service';
import { SeniorPlacementService } from 'app/_core/api-access/senior-placement.service';
import { MediaService } from 'app/_core/api-access/media.service';
import { SeniorPlacement } from 'app/_core/models/senior-placement';

@Component({
  selector: 'app-senior-placement-list',
  templateUrl: './senior-placement-list.component.html'
})

export class SeniorPlacementListComponent extends BaseActComponent implements OnInit {

  public readonly seniorPlacements$: Observable<SeniorPlacement[]>;
  public readonly pageInfo$: Observable<PageInfo>;
  public readonly geoType = GeoType;

  // Keep form value
  public seniorPlacementFilter: SeniorPlacementFilter = new SeniorPlacementFilter();

  // Pagination
  public pageOffset: number;
  public pageLimit: number;
  public pageNumberSelected: number;

  public globalData: ListOfValues;

  constructor(
    private seniorPlacementService: SeniorPlacementService,
    private route: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService,
    private mediaService: MediaService,) {
    super();

    // Subscribe to entire collection
    this.seniorPlacements$ = this.seniorPlacementService.seniorPlacementsObs;
    // Page info
    this.pageInfo$ = this.seniorPlacementService.pageInfoObs;
  }

  loadGlobal(loadNew: boolean = false) {
    if (this.globalService.getCacheGlobal() && !loadNew)
      this.globalData = this.globalService.getCacheGlobal();
    else
      this.globalService.getGlobal().pipe(first()).subscribe(global => {
        this.globalData = global;
        this.globalService.setCacheGlobal(global);
        this.seniorPlacementFilter.Languages = this.globalData.Languages.filter(language => language.Name === "English");
      });
  }

  ngOnInit(): void {
    this.loadGlobal();
    // Process
    this.route.queryParamMap.subscribe(params => {
      // Get filter values from params
      this.seniorPlacementFilter.GeoId = +params.get('geo_id');
      this.seniorPlacementFilter.GeoType = params.get('geo_type');
      this.seniorPlacementFilter.GeoName = params.get('geo_name');

      // TODO: should get it from api, get detail for geotype and id above, or return on result together.
      this.seniorPlacementFilter.GeoCityId = +params.get("geo_city_id");
      this.seniorPlacementFilter.GeoCityName = params.get("geo_city_name");
      this.seniorPlacementFilter.GeoCountyId = +params.get("geo_county_id");
      this.seniorPlacementFilter.GeoCountyName = params.get("geo_county_name");
      this.seniorPlacementFilter.GeoStateId = +params.get("geo_state_id");
      this.seniorPlacementFilter.GeoStateName = params.get("geo_state_name");

       //set default language
      if(this.globalData && this.globalData.Languages){
        this.seniorPlacementFilter.Languages = this.globalData.Languages.filter(language => language.Name === "English");
      }else{
        this.loadGlobal(true);
      }

      // Pagination
      const offset: number = +params.get("page_offset");
      this.pageOffset = offset ? offset : 0;

      const limit: number = +params.get("page_limit");
      this.pageLimit = limit ? limit : 4;

      // Load data
      this.seniorPlacementService.load(this.pageOffset, this.pageLimit, this.seniorPlacementFilter);
    });
  }

  getImageUrl(guid: string) {
    return this.mediaService.getImageUrl(guid);
  }

  onPaginationChange(pageNumber: number, totalPage: number) {
    if (pageNumber < 1 || pageNumber > totalPage) {
      return;
    }

    this.pageNumberSelected = pageNumber;
    this.pageOffset = (pageNumber - 1) * this.pageLimit;

    // Load data with new page and current condition
    this.seniorPlacementService.load(this.pageOffset, this.pageLimit, this.seniorPlacementFilter);
  }

  redirectTo(uri: string, params: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      // Query params
      params ? this.router.navigate([uri], { queryParams: params }) : this.router.navigate([uri])
    );
  }

  getFilter(filter: SeniorPlacementFilter) {
    // Redirect to page with filter on side
    const params = {};

    if(filter.GeoId) {
      params['geo_id'] = filter.GeoId;
      params['geo_type'] = filter.GeoType;
      params['geo_name'] = filter.GeoName;
    }

    if(filter.GeoCityId) {
      params['geo_city_id'] = filter.GeoCityId;
      params['geo_city_name'] = filter.GeoCityName;
    }

    if(filter.GeoCityId) {
      params['geo_county_id'] = filter.GeoCountyId;
      params['geo_county_name'] = filter.GeoCountyName;
    }

    if(filter.GeoStateId) {
      params['geo_state_id'] = filter.GeoStateId;
      params['geo_state_name'] = filter.GeoStateName;
    }

    if(filter.Distmi)
      params['distmi'] = filter.Distmi;

    if(filter.Languages)
      params['language_ids'] = filter.Languages.map(l => l.Id).join();


    this.redirectTo(this.path.Senior_Placements_Extend, params);
  }
}
